import { sessionDataHandler } from './sessionDataHandler'

export const SESSION_DATA_IDENTIFIER = 'session'

type SessionData =
  | {
      token: string
    }
  | undefined

export const fetchSessionData = () =>
  sessionDataHandler.getItem<SessionData>(SESSION_DATA_IDENTIFIER)

export const storeSessionData = (sessionData?: SessionData) => {
  // Write to both localStorage (for migration) and localforage
  // Reads still come from localforage until migration is complete
  if (sessionData !== undefined) {
    localStorage.setItem(SESSION_DATA_IDENTIFIER, JSON.stringify(sessionData))
  } else {
    localStorage.removeItem(SESSION_DATA_IDENTIFIER)
  }
  return sessionDataHandler.setItem<SessionData>(SESSION_DATA_IDENTIFIER, sessionData)
}

/**
 * Removes session data from both localStorage and localforage.
 * Used during logout and SSO re-auth flows.
 */
export const removeSessionData = () => {
  localStorage.removeItem(SESSION_DATA_IDENTIFIER)
  return sessionDataHandler.removeItem(SESSION_DATA_IDENTIFIER)
}
